// extracted by mini-css-extract-plugin
export default {"insuranceCertificate":"cwNc6DKuL_4J3Nj7vRo4","infoWrapper":"PmdOYcP5c8OXVtatOG7e","fileName":"VAE9cvw6NqWavGOvkaDp","dateWrapper":"S5ojG_Jw1QyDVH6J8WUA"};